export interface UnidadMedida {
    codigo: number;
    representacion: string;
    descripcion: string;
}

export const UNIDADES_MEDIDA: UnidadMedida[] = [
    { codigo: 77, representacion: "UNI", descripcion: "Unidad" },
    { codigo: 83, representacion: "kg", descripcion: "Kilogramos" },
    { codigo: 86, representacion: "g", descripcion: "Gramos" },
    { codigo: 87, representacion: "m", descripcion: "Metros" },
    { codigo: 88, representacion: "ML", descripcion: "Mililitros" },
    { codigo: 89, representacion: "LT", descripcion: "Litros" },
    { codigo: 90, representacion: "MG", descripcion: "Miligramos" },
    { codigo: 91, representacion: "CM", descripcion: "Centímetros" },
    { codigo: 92, representacion: "CM2", descripcion: "Centímetros cuadrados" },
    { codigo: 93, representacion: "CM3", descripcion: "Centímetros cúbicos" },
    { codigo: 94, representacion: "PUL", descripcion: "Pulgadas" },
    { codigo: 95, representacion: "MM", descripcion: "Milímetros" },
    { codigo: 96, representacion: "MM2", descripcion: "Milímetros cuadrados" },
    { codigo: 97, representacion: "AA", descripcion: "Año" },
    { codigo: 98, representacion: "ME", descripcion: "Mes" },
    { codigo: 99, representacion: "TN", descripcion: "Tonelada" },
    { codigo: 100, representacion: "Hs", descripcion: "Hora" },
    { codigo: 101, representacion: "Mi", descripcion: "Minuto" },
    { codigo: 102, representacion: "Di", descripcion: "Día" },
    { codigo: 103, representacion: "Ya", descripcion: "Yardas" },
    { codigo: 104, representacion: "DET", descripcion: "Determinación" },
    { codigo: 108, representacion: "MT", descripcion: "Metros" },
    { codigo: 109, representacion: "M2", descripcion: "Metros cuadrados" },
    { codigo: 110, representacion: "M3", descripcion: "Metros cúbicos" },
    { codigo: 569, representacion: "ración", descripcion: "Ración" },
    { codigo: 625, representacion: "Km", descripcion: "Kilómetros" },
    { codigo: 660, representacion: "ml", descripcion: "Metro lineal" },
    { codigo: 666, representacion: "Se", descripcion: "Segundo" },
    { codigo: 79, representacion: "kg/m2", descripcion: "Kilogramos s/ metro cuadrado" },
    { codigo: 869, representacion: "ha", descripcion: "Hectáreas" },
    { codigo: 885, representacion: "GL", descripcion: "Unidad Medida Global" },
    { codigo: 891, representacion: "pm", descripcion: "Por Milaje" },
    { codigo: 2329, representacion: "UI", descripcion: "Unidad Internacional" },
    { codigo: 2366, representacion: "CPM", descripcion: "Costo por Mil" }
].sort((a, b) => a.descripcion.localeCompare(b.descripcion));

export const getUnidadMedidaByCodigo = (codigo: number): UnidadMedida | undefined => {
    return UNIDADES_MEDIDA.find(u => u.codigo === codigo);
};

export const getDescripcionUnidadMedida = (codigo: number): string => {
    const unidad = getUnidadMedidaByCodigo(codigo);
    return unidad ? unidad.representacion : `Código ${codigo}`;
};
